module.exports = __webpack_public_path__ + "img/126.4.6a8326a5.png";